import { render, staticRenderFns } from "./IconLoadingSpinner.vue?vue&type=template&id=572d7886&scoped=true&"
import script from "./IconLoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./IconLoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./IconLoadingSpinner.vue?vue&type=style&index=0&id=572d7886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d7886",
  null
  
)

export default component.exports